import React from 'react';
import { Typography } from '@mui/material';
import { YardReciptData } from '@Src/_basic/object/YardReceiptsType';

interface Props {
  row: YardReciptData;
}
export default function SpecificationValueColumnFormatter(props: Props) {
  const { row } = props;
  return (
    <>
      {row.specification1Value ? (
        <Typography variant="inherit">{row.specification1Value}</Typography>
      ) : (
        <Typography variant="inherit">&nbsp;</Typography>
      )}
      {row.specification2Value ? (
        <Typography variant="inherit">{row.specification2Value}</Typography>
      ) : (
        <Typography variant="inherit">&nbsp;</Typography>
      )}
      {row.specification3Value ? (
        <Typography variant="inherit">{row.specification3Value}</Typography>
      ) : (
        <Typography variant="inherit">&nbsp;</Typography>
      )}
    </>
  );
}
